const indexItems = [
  { emoji: '🔥', label: '今日热点', count: '32条', color: 'bg-primary-100 text-primary-700' },
  { emoji: '🎬', label: '娱乐圈', count: '28条', color: 'bg-accent-100 text-accent-700' },
  { emoji: '📱', label: '网红动态', count: '21条', color: 'bg-secondary-100 text-secondary-700' },
  { emoji: '💬', label: '社会热议', count: '19条', color: 'bg-primary-100 text-primary-700' },
  { emoji: '🎵', label: '音乐八卦', count: '15条', color: 'bg-accent-100 text-accent-700' },
  { emoji: '🏀', label: '体育圈', count: '13条', color: 'bg-secondary-100 text-secondary-700' },
  { emoji: '🌍', label: '国际吃瓜', count: '10条', color: 'bg-primary-100 text-primary-700' },
  { emoji: '😂', label: '搞笑合集', count: '24条', color: 'bg-accent-100 text-accent-700' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 px-4 md:px-6 scroll-mt-20">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            吃瓜索引
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            按分类快速找到你想吃的瓜，总有一款合你口味
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {indexItems.map((item, i) => (
            <a
              key={i}
              href={`#carousel`}
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex flex-col items-center gap-3 p-5 bg-background-50 rounded-2xl border border-background-200/60 hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className={`w-16 h-16 rounded-2xl flex items-center justify-center text-2xl ${item.color}`}>
                {item.emoji}
              </div>
              <span className="text-sm font-semibold text-foreground-800 whitespace-nowrap">{item.label}</span>
              <span className="text-xs text-foreground-400">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}